export default __webpack_public_path__ + "static/media/whale-banner.838d96e1.png";